import React, { useEffect, useState } from "react";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import { Notification } from "../Notifications/Notification";
import customerIcon from "../../assets/images/customer_icon.png";
import revenueIcon from "../../assets/images/revenue_icon.png";
import profitIcon from "../../assets/images/profit_icon.png";
import orderIcon from "../../assets/images/order_icon.png";
import { Typography } from "@material-ui/core";
import { useHomeStyles } from "./useHomeStyles";
import { useStore } from "../../store";
import { WeeklySalesReport } from "./WeeklySalesReport";
import { DepartmentSalesReport } from "./DepartmentSalesReport";
import { DailySalesReport } from "./DailySalesReport";
import { Helmet } from "react-helmet-async";
import { api } from "../../api";

type permissionType = {
  permission_id: number;
  is_add: boolean;
  is_edit: boolean;
  is_view: boolean;
  is_delete: boolean;
};

export const HomePage = () => {
  const classes = useHomeStyles();
  const [user] = useStore("auth", "user");
  const [departmentsChart] = useStore("departmentsChart");
  const [weeklySales] = useStore("weeklySales");
  const [dailySales] = useStore("dailySales");
  const [salesReportData] = useStore("salesReportData");

  const [permissionFlag, setPermissionFlag] = useState<boolean>(false);
  const [viewRolePermission, setViewRolePermission] = useState<boolean>(false);
  const [departmentReport, setDepartmentReport] = useState<any>(
    departmentsChart
  );
  const [weeklySalesReport, setWeeklySalesReport] = useState<any>(weeklySales);
  const [dailySalesReport, setDailySalesReport] = useState<any>(dailySales);
  const [salesReport, setSalesReport] = useState<any>(salesReportData);

  useEffect(() => {
    const notificationPermission = user.permissions.find(
      (permission: permissionType) => permission.permission_id === 1
    );
    const homeDataPermission = user.permissions.find(
      (permission: permissionType) => permission.permission_id === 17
    );

    if (user.is_super_admin === true) {
      setPermissionFlag(true);
      setViewRolePermission(true);
    } else {
      if (notificationPermission) {
        if (notificationPermission.is_view === true) {
          setPermissionFlag(true);
        }
      }
      if (homeDataPermission) {
        if (homeDataPermission.is_view === true) {
          setViewRolePermission(true);
        }
      }
    }
    try {
      const interval = setInterval(async () => {
        Promise.all([
          api.get(`home/department`),
          api.get(`home/weeklysales`),
          api.get(`home/sales`),
          api.get(`home/dailysales`),
        ]).then((values) => {
          setDepartmentReport(values[0]);
          setWeeklySalesReport(values[1]);
          setSalesReport(values[2]);
          setDailySalesReport(values[3]);
        });
      }, 1.8e6);
      return () => clearInterval(interval);
    } catch (e) {
      console.log("error..", e);
    }
  });

  return (
    <>
      <Helmet>
        <title>FFC POS</title>
      </Helmet>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} md={3}>
          <Paper className={classes.paper}>
            <Grid container spacing={3} alignItems="center" justify="center">
              <Grid item xs={5} sm={3}>
                <img src={revenueIcon} alt="revenueIcon" />
              </Grid>
              <Grid item xs={7} sm={9}>
                <Typography className={classes.cardFirstSubHead}>
                  Gross
                </Typography>
                <Typography className={classes.cardAmountStyles}>
                  {viewRolePermission
                    ? salesReport !== undefined
                      ? salesReport[0].cd_gross === null
                        ? "0"
                        : salesReport[0].cd_gross
                      : ""
                    : "0"}
                </Typography>
                <Typography className={classes.cardSecondSubHead}>
                  Total Gross
                </Typography>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Paper className={classes.paper}>
            <Grid container spacing={3} alignItems="center" justify="center">
              <Grid item xs={5} sm={3}>
                <img src={profitIcon} alt="profitIcon" />
              </Grid>
              <Grid item xs={7} sm={9}>
                <Typography className={classes.cardFirstSubHead}>
                  Net
                </Typography>
                <Typography className={classes.cardAmountStyles}>
                  {viewRolePermission
                    ? salesReport !== undefined
                      ? salesReport[0].cd_net === null
                        ? "0"
                        : salesReport[0].cd_net
                      : ""
                    : "0"}
                </Typography>
                <Typography className={classes.cardSecondSubHead}>
                  Total Net
                </Typography>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Paper className={classes.paper}>
            <Grid container spacing={3} alignItems="center" justify="center">
              <Grid item xs={5} sm={3}>
                <img src={orderIcon} alt="orderIcon" />
              </Grid>
              <Grid item xs={7} sm={9}>
                <Typography className={classes.cardFirstSubHead}>
                  Return
                </Typography>
                <Typography className={classes.cardAmountStyles}>
                  {viewRolePermission
                    ? salesReport !== undefined
                      ? salesReport[0].cd_return === null
                        ? "0"
                        : salesReport[0].cd_return
                      : ""
                    : "0"}
                </Typography>
                <Typography className={classes.cardSecondSubHead}>
                  Total Returns
                </Typography>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Paper className={classes.paper}>
            <Grid container spacing={3} alignItems="center" justify="center">
              <Grid item xs={5} sm={3}>
                <img src={customerIcon} alt="customerIcon" />
              </Grid>
              <Grid item xs={7} sm={9}>
                <Typography className={classes.cardFirstSubHead}>
                  Customers
                </Typography>
                <Typography className={classes.cardAmountStyles}>
                  {viewRolePermission
                    ? salesReport !== undefined
                      ? salesReport[0].cd_billcount === null
                        ? "0"
                        : salesReport[0].cd_billcount
                      : ""
                    : "0"}
                </Typography>
                <Typography className={classes.cardSecondSubHead}>
                  Total Customers
                </Typography>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Paper className={classes.paper}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Typography
                  style={{
                    textAlign: "left",
                    color: "#233298",
                    fontWeight: "bold",
                    fontSize: "0.875rem",
                  }}
                  gutterBottom
                >
                  Daily Sales
                </Typography>
                <Typography
                  style={{ textAlign: "left", fontSize: "0.813rem" }}
                  gutterBottom
                >
                  Overall Sales Revenue and Profit Performance online & offline
                </Typography>
              </Grid>
              <Grid item xs={12} style={{ paddingTop: "1em" }}>
                <DailySalesReport
                  dailySales={viewRolePermission ? dailySalesReport : []}
                />
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Paper className={classes.paper}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Typography
                  style={{
                    textAlign: "left",
                    color: "#233298",
                    fontWeight: "bold",
                    fontSize: "0.875rem",
                  }}
                  gutterBottom
                >
                  Department Sales
                </Typography>
                <Typography
                  style={{ textAlign: "left", fontSize: "0.813rem" }}
                  gutterBottom
                >
                  Overall Sales Revenue and Profit Performance online & offline
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <DepartmentSalesReport
                  departmentsChart={viewRolePermission ? departmentReport : []}
                  viewRolePermission={viewRolePermission}
                />
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Paper className={classes.paper}>
            <Grid container spacing={3}>
              <Grid item>
                <Typography
                  style={{
                    textAlign: "left",
                    color: "#233298",
                    fontWeight: "bold",
                    fontSize: "0.875rem",
                  }}
                  gutterBottom
                >
                  Weekly Sales
                </Typography>
                <Typography
                  style={{ textAlign: "left", fontSize: "0.813rem" }}
                  gutterBottom
                >
                  Overall Sales Revenue and Profit Performance online & offline
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <WeeklySalesReport
                  weeklySales={viewRolePermission ? weeklySalesReport : []}
                  viewRolePermission={viewRolePermission}
                />
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6}>
          {permissionFlag ? (
            <Grid item xs={12}>
              <Notification />
            </Grid>
          ) : (
            ""
          )}
        </Grid>
      </Grid>
    </>
  );
};
